<template>
    <div class="mt-3 mb-5 category-listing-group">
        <div class="row category-listing-header no-gutters">
            <div class="col-12 peer-program-category-header">
                <h4 @click="collapseAndSaveState()">{{category_group_title}}</h4>
                <a class="accordion-top-right small-text" href="#" @click.prevent="collapseAndSaveState()">{{closeOpenText}}
                    <closeicon v-if="closeOpenText == 'hide'"></closeicon>
                    <closeicon v-else class="rotate-45"></closeicon>
                </a>
            </div>
        </div>

        <div class="category-listing" v-show="categoryListingVisible">
            <div class="listing-item" v-for="category in categoriesToShow">
                <a :href="category[0]['category_url']" class="category-item">{{ category[0]['meta_data']['category_name'] }}
                    <caretright class="float-right"></caretright>
                </a>
            </div>
        </div>
    </div>
</template>

<script>
    import closeicon from '../vue-components/icons/close.vue';
    import caretright from '../vue-components/icons/caret_right.vue';

    export default {
        components: { closeicon, caretright },
        props: ['categories', 'category_group_title', 'election_type'],
        data() {
            return {
                categoryListingVisible: true,
                categoriesToShow: this.categories,
                closeOpenText: 'hide',
            }
        },
        watch: {
            categoryListingVisible: function(val) {
                if(val) {
                    this.closeOpenText = 'hide';
                } else {
                    this.closeOpenText = 'show'
                }
            }
        },
        created: function() {
            let that = this;
            var electionTypeStorage = localStorage.getItem('electiontype');
            if(electionTypeStorage && electionTypeStorage != this.election_type) {
                localStorage.removeItem(that.category_group_title)
            }
            var categoryListingClosed = localStorage.getItem(that.category_group_title);
            if(categoryListingClosed == '0') {
                that.categoryListingVisible = false;
            }
            if(that.categoryListingVisible) {
                this.closeOpenText = 'hide';
            } else {
                this.closeOpenText = 'show';
            }
        },
        methods: {
            voteCategory: function(category) {
                let that = this;
                if(this.votes) {
                    return checkIfVotedAlready(that.votes, category['id']);
                } else {
                    return false;
                }
            },
            collapseAndSaveState: function() {
                let that = this;
                this.categoryListingVisible = !this.categoryListingVisible
                var categoryListingSave = localStorage.getItem(that.category_group_title);
                if (localStorage.getItem(that.category_group_title) === null) {
                    localStorage.setItem(that.category_group_title, 0)
                } else {
                    var categoryListingSave = localStorage.getItem(that.category_group_title);
                    if(categoryListingSave == 0) {
                        localStorage.setItem(that.category_group_title, 1)
                    } else {
                        localStorage.setItem(that.category_group_title, 0)
                    }
                }
                localStorage.setItem('electiontype', that.election_type);
            }
        }
    }

    function checkIfVotedAlready(arr, val) {
        return arr.some(function(arrVal) {
            return val == arrVal.category_id;
        });
    }


</script>
